export default [
  {
    name: 'Sobre',
    url: '/sobre/',
  },
  {
    name: 'Empreendimentos',
    url: '/empreendimentos/',
  },
  {
    name: 'Revendas',
    url: '/revendas/',
    menuBar: true,
  },
  {
    name: 'Contato',
    url: '/contato/',
  },
]
